import { connect } from 'react-redux'
import { doToggleTicketState } from 'actions/tickets'

import {
  makeSelectTicketFlags,
  makeSelectTicketSnoozedUntil,
  makeSelectTicketStateLabel,
  makeSelectTicketInvertStateActionLabel,
} from 'selectors/tickets'

import View from './view'

const select = () => {
  const selectTicketFlags = makeSelectTicketFlags()
  const selectTicketSnoozedUntil = makeSelectTicketSnoozedUntil()
  const selectTicketStateLabel = makeSelectTicketStateLabel()
  const selectTicketInvertStateActionLabel = makeSelectTicketInvertStateActionLabel()

  return (state, props) => {
    const {
      isDeleted,
      isSnoozed,
      isOpen,
      isClosed,
      isUnread,
    } = selectTicketFlags(state, props)
    return {
      isDeleted,
      isSnoozed,
      isOpen,
      isClosed,
      isUnread,
      snoozedUntil: selectTicketSnoozedUntil(state, props),
      stateLabel: selectTicketStateLabel(state, props),
      invertStateActionLabel: selectTicketInvertStateActionLabel(state, props),
    }
  }
}

const perform = {
  toggleTicketState: doToggleTicketState,
}

export default connect(select, perform)(View)
